/* 三國逗陣打 · 局外成長：軍階、武將熟練度、造型、每日軍令、戰功、評價與挑戰碼
 * 不碰 DOM；只用 localStorage 存檔（讀不到就當新玩家），Node 測試可直接載入 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const KEY = 'sankuo-profile';
const store = (() => { try { return window.localStorage || null; } catch (e) { return null; } })();

// ---------- 軍階（累積軍功） ----------
const RANKS = [[0, '白身'], [300, '伍長'], [800, '什長'], [1600, '百夫長'], [2800, '校尉'], [4500, '都尉'], [7000, '偏將軍'], [10500, '將軍'], [15000, '大將軍'], [21000, '大司馬'], [30000, '丞相']];
function rankOf(xp) {
  let i = 0;
  while (i + 1 < RANKS.length && xp >= RANKS[i + 1][0]) i++;
  const cur = RANKS[i][0], next = RANKS[i + 1] ? RANKS[i + 1][0] : null;
  return { i, name: RANKS[i][1], cur, next, frac: next ? (xp - cur) / (next - cur) : 1, nextName: RANKS[i + 1] ? RANKS[i + 1][1] : null };
}

// ---------- 武將熟練度（每將各自累積，解鎖造型） ----------
const MASTERY = [0, 250, 650, 1300, 2300, 3800, 6000];
const MASTERY_NAME = ['初出茅廬', '略有小成', '熟練', '精通', '專精', '大師', '名震天下'];
function masteryOf(xp) {
  let lv = 0;
  while (lv + 1 < MASTERY.length && xp >= MASTERY[lv + 1]) lv++;
  const next = MASTERY[lv + 1];
  return { lv, name: MASTERY_NAME[lv], cur: MASTERY[lv], next: next == null ? null : next, frac: next == null ? 1 : (xp - MASTERY[lv]) / (next - MASTERY[lv]) };
}

// ---------- 造型：同一套骨架換配色，依熟練度解鎖（日後的付費造型也走這裡） ----------
const shade = (hex, k) => {
  const n = parseInt(hex.slice(1), 16), f = (v) => Math.max(0, Math.min(255, Math.round(k < 0 ? v * (1 + k) : v + (255 - v) * k)));
  return '#' + [n >> 16, (n >> 8) & 255, n & 255].map((v) => f(v).toString(16).padStart(2, '0')).join('');
};
const SKINS = [
  { id: 'base', name: '本色', lv: 0, desc: '史書上的模樣' },
  { id: 'xuan', name: '玄甲', lv: 2, desc: '夜襲用的黑漆鐵甲', c: (c) => ({ armor: '#2b2b33', sleeve: shade(c.sleeve || '#333', -0.55), cloth: shade(c.cloth || '#333', -0.55), metal: '#6a6f7c', hood: '#24242a', cape: '#1c1c22', trim: '#b88a3a', plume: '#d23a2e' }), fx: '#ff5a4a' },
  { id: 'jin', name: '金甲', lv: 4, desc: '凱旋受封的鎏金戰袍', c: (c) => ({ armor: '#c99a3e', sleeve: shade(c.sleeve || '#555', -0.25), metal: '#ecd28a', trim: '#fff0b8', cape: '#8e2b22', plume: '#ffd46b', pole: '#8a5a1e' }), fx: '#ffd46b', aura: '#ffd46b' },
  { id: 'shuang', name: '霜天', lv: 6, desc: '名震天下者才能披上的白銀霜甲', c: () => ({ armor: '#dfe8f2', sleeve: '#8fa6c8', cloth: '#9fb6d8', metal: '#e8f4ff', hood: '#c8d8ec', cape: '#2f4f86', trim: '#9fe7ff', plume: '#9fe7ff', pants: '#3a4a66' }), fx: '#9fe7ff', aura: '#9fe7ff' },
  // 商域造型：不看熟練度，每名武將各自購買（price 是銅錢或黃金）
  { id: 'zhu', name: '朱漆', price: { copper: 1500 }, desc: '朱紅漆甲，出陣如火', c: (c) => ({ armor: '#9e2a22', sleeve: shade(c.sleeve || '#555', -0.3), cloth: '#6e1c18', metal: '#d8b26a', trim: '#f0d08a', cape: '#5a1410', plume: '#ffcf6a' }), fx: '#ff7a4a' },
  { id: 'qing', name: '青銅', price: { copper: 2500 }, desc: '鑄紋青銅甲，古樸厚重', c: (c) => ({ armor: '#4e7a62', sleeve: shade(c.sleeve || '#555', -0.35), cloth: '#2f4a3c', metal: '#b9a46a', trim: '#d9c48a', cape: '#24382d', plume: '#8fd19e' }), fx: '#8fd19e' },
  { id: 'mo', name: '墨染', price: { gold: 60 }, desc: '水墨山水間走出的俠客', c: () => ({ armor: '#e8e2d4', sleeve: '#2a2a2e', cloth: '#3a3a40', metal: '#1c1c20', hood: '#2a2a2e', cape: '#151518', trim: '#8e2b22', plume: '#151518', pants: '#2a2a2e' }), fx: '#e8e2d4', aura: '#cfc8b8' },
  { id: 'long', name: '龍吟', price: { gold: 128 }, desc: '玉帶金鱗，龍吟九霄', c: () => ({ armor: '#2f8a7a', sleeve: '#1f5a50', cloth: '#1d4a44', metal: '#f2d27a', trim: '#fff0b8', cape: '#8e2b22', plume: '#f2d27a', pants: '#173a36' }), fx: '#7fffd4', aura: '#f2d27a' },
  // 節慶限定：只在活動期間上架，買到的永久保留；acc 是戴在頭上的配件（rig.ts drawAcc）
  // 萬聖節：只給四名知名武將，各有一款專屬造型（heroes 限定能買的武將）
  { id: 'gui', legend: 'gui', name: '鬼燈武聖', event: 'halloween', heroes: ['guanyu'], acc: 'witch', price: { copper: 2000 }, desc: '萬聖夜裡提燈巡營，青龍刀上燃著鬼火', c: () => ({ armor: '#3a2350', sleeve: '#2a1a3a', cloth: '#24162f', metal: '#ff8a1e', hood: '#1c1226', cape: '#ff8a1e', trim: '#b6ff5a', plume: '#b6ff5a', pants: '#1c1226', band: '#ff8a1e' }), fx: '#b6ff5a', aura: '#ff8a1e' },
  { id: 'nangua', legend: 'nangua', name: '南瓜軍師', event: 'halloween', heroes: ['zhugeliang'], acc: 'pumpkin', price: { copper: 2000 }, desc: '借東風不如借南瓜，羽扇一搖滿營燈火', c: () => ({ armor: '#e0761e', sleeve: '#2a2228', cloth: '#2a2228', metal: '#ffb347', hood: '#e0761e', cape: '#1c1418', trim: '#3f8a3a', plume: '#3f8a3a', pants: '#1c1418', belt: '#e0761e' }), fx: '#ffb347', aura: '#ff8a1e' },
  { id: 'yecha', legend: 'yecha', name: '夜叉公瑾', event: 'halloween', heroes: ['zhouyu'], acc: 'horns', price: { copper: 2000 }, desc: '赤壁的火燒到了陰間，連夜叉都要聽他調度', c: () => ({ armor: '#7a1420', sleeve: '#1c1014', cloth: '#1c1014', metal: '#ff4a3a', hood: '#7a1420', cape: '#2a0a10', trim: '#ff4a3a', plume: '#ff4a3a', pants: '#140a0e' }), fx: '#ff4a3a', aura: '#c81e2e' },
  { id: 'jiangshi', legend: 'jiangshi', name: '殭屍孟德', event: 'halloween', heroes: ['caocao'], acc: 'jiangshi', price: { copper: 2000 }, desc: '寧教我負天下符，休教天下符負我', c: () => ({ armor: '#2a4a5a', sleeve: '#1e3644', cloth: '#1e3644', metal: '#e8d27a', hood: '#16161c', cape: '#16161c', trim: '#c8281e', plume: '#c8281e', pants: '#16161c' }), fx: '#9fffc8', aura: '#7fd8a0' },
  { id: 'xue', name: '雪夜', event: 'xmas', acc: 'santa', price: { copper: 2000 }, desc: '雪夜行軍，替弟兄們送來暖酒', c: () => ({ armor: '#c22a2a', sleeve: '#8e1c1c', cloth: '#f2f2f2', metal: '#f2f2f2', hood: '#c22a2a', cape: '#1f6a3a', trim: '#ffffff', plume: '#ffffff', pants: '#3a2020', band: '#c22a2a' }), fx: '#e8f6ff', aura: '#e8f6ff' },
  { id: 'chun', name: '迎春', event: 'cny', acc: 'wusha', price: { copper: 2500 }, desc: '正月出巡的財神官袍，見者發財', c: () => ({ armor: '#c8281e', sleeve: '#a01e18', cloth: '#a01e18', metal: '#ffd46b', hood: '#c8281e', cape: '#ffd46b', trim: '#ffd46b', plume: '#ffd46b', pants: '#5a1410', band: '#ffd46b' }), fx: '#ffd46b', aura: '#ff5a3a' },
  { id: 'tu', name: '玉兔', event: 'moon', acc: 'bunny', price: { copper: 2000 }, desc: '月宮搗藥歸來，衣上還沾著桂花', c: () => ({ armor: '#f2efe6', sleeve: '#c9d6ec', cloth: '#dfe6f2', metal: '#f2d27a', hood: '#f2efe6', cape: '#7a8fc8', trim: '#f2d27a', plume: '#ffc0d0', pants: '#5a6a96', band: '#f2d27a' }), fx: '#fff3c0', aura: '#fff3c0' },
];

// ---------- 節慶活動：from/to 寫 MM-DD 就每年同一天；農曆節日每年不同，寫完整日期 YYYY-MM-DD ----------
const EVENTS = [
  { id: 'halloween', name: '百鬼夜行', fest: '萬聖節', from: '10-24', to: '11-07', color: '#ff8a1e', desc: '關羽、諸葛亮、周瑜、曹操換上萬聖節專屬造型。活動期間限定販售，買到的永久保留。' },
  { id: 'xmas', name: '雪夜', fest: '聖誕節', from: '12-18', to: '01-03', color: '#e8f6ff', desc: '聖誕到跨年限定造型「雪夜」上架，活動結束就下架，買到的永久保留。' },
  { id: 'cny', name: '迎春', fest: '農曆新年', from: '2027-01-30', to: '2027-02-20', color: '#ffd46b', desc: '新春限定造型「迎春」上架，活動結束就下架，買到的永久保留。' },
  { id: 'moon', name: '玉兔', fest: '中秋節', from: '2027-09-08', to: '2027-09-22', color: '#fff3c0', desc: '中秋限定造型「玉兔」上架，活動結束就下架，買到的永久保留。' },
];
// 預覽：本機開發可用 ?event=<id> 強制開某個活動（正式網站不理會）
const forcedEvent = () => {
  if (SG.EVENT_FORCE) return SG.EVENT_FORCE;
  try { const l = window.location; if (/^(localhost|127\.)/.test(l.hostname)) return new URLSearchParams(l.search).get('event'); } catch (e) { /* Node 測試沒有 location */ }
  return null;
};
// 回傳這個活動在 d 當天是否進行中，以及這一檔的起訖日
function eventWindow(ev, d) {
  const day = today(d), y = d.getFullYear();
  if (ev.from.length > 5) return day >= ev.from && day <= ev.to ? { start: ev.from, end: ev.to } : null;
  // 每年同一天；跨年的活動（12-18 到 01-03）分成去年開始、今年開始兩種
  for (const sy of [y - 1, y]) {
    const from = sy + '-' + ev.from, to = (ev.to < ev.from ? sy + 1 : sy) + '-' + ev.to;
    if (day >= from && day <= to) return { start: from, end: to };
  }
  return null;
}
const SOON = 30; // 開始前幾天在首頁預告
const dayOffset = (d, n) => new Date(d.getTime() + n * 864e5);
const daysTo = (d, ymd) => Math.max(0, Math.ceil((new Date(ymd + 'T23:59:59').getTime() - d.getTime()) / 864e5));
// 每款造型能穿的武將：有 heroes 就只限那幾名
function eventPicks(ev) {
  return SKINS.filter((k) => k.event === ev.id).flatMap((k) => (k.heroes || []).map((id) => ({ hero: SG.HEROES.find((h) => h.id === id), skin: k })).filter((x) => x.hero));
}
// 進行中的活動（on）＋即將開始的活動（預告）；left 是剩幾天，until 是幾天後開始
function eventsAround(d) {
  d = d || new Date();
  const f = forcedEvent();
  return EVENTS.map((ev) => {
    const base = { skins: SKINS.filter((k) => k.event === ev.id), picks: eventPicks(ev) };
    if (f) return f === ev.id ? Object.assign({}, ev, base, { on: true, start: today(d), end: today(dayOffset(d, 7)), left: daysTo(d, today(dayOffset(d, 7))) }) : null;
    const w = eventWindow(ev, d);
    if (w) return Object.assign({}, ev, base, { on: true, start: w.start, end: w.end, left: daysTo(d, w.end) });
    for (let i = 1; i <= SOON; i++) {
      const n = eventWindow(ev, dayOffset(d, i));
      if (n) return Object.assign({}, ev, base, { on: false, start: n.start, end: n.end, until: i });
    }
    return null;
  }).filter(Boolean);
}
const activeEvents = (d) => eventsAround(d).filter((e) => e.on);
const eventOn = (id, d) => activeEvents(d).some((e) => e.id === id);
function skinned(hero, skinId) {
  const sk = SKINS.find((s) => s.id === skinId);
  if (!sk || !sk.c) return hero;
  const h = Object.assign({}, hero);
  h.c = Object.assign({}, hero.c, sk.c(hero.c));
  if (sk.fx) h.fx = sk.fx;
  if (sk.aura) h.aura = sk.aura;
  if (sk.acc) h.acc = sk.acc;
  if (sk.legend) h.legend = sk.legend; // 傳說級（萬聖）：換兵器、技能特效，見 render/skinfx.ts
  h.skinId = sk.id; h.skinName = sk.name;
  return h;
}

// ---------- 存檔 ----------
// 「今天」一律用台灣時間：每日軍令、每日特惠、今日武將在伺服器（UTC）與各地瀏覽器都算出同一天
const today = (d) => new Date((d ? d.getTime() : Date.now()) + 8 * 3600e3).toISOString().slice(0, 10);
const fresh = () => ({ v: 1, xp: 0, games: 0, wins: 0, winStreak: 0, bestStreak: 0, heroes: {}, skin: {}, ach: {}, factionsWon: {}, daily: null, login: { last: null, days: 0 }, history: [], tips: {}, best: {},
  copper: 500, gold: 0, owned: {}, boost: { xp2: 0, m2: 0 }, topups: {}, nick: '' });
let P = fresh();
function load() {
  try { const raw = store && store.getItem(KEY); if (raw) P = Object.assign(fresh(), JSON.parse(raw)); } catch (e) { P = fresh(); }
  P.boost = Object.assign({ xp2: 0, m2: 0 }, P.boost);
  return P;
}
const saveHooks: ((p: any) => void)[] = []; // 存檔後通知（雲端存檔用：src/game/cloud.ts）
function save() { try { if (store) store.setItem(KEY, JSON.stringify(P)); } catch (e) { /* 存不了就算了，本局照玩 */ } for (const f of saveHooks) try { f(P); } catch (e) { /* 忽略 */ } }
const heroRec = (id) => (P.heroes[id] = P.heroes[id] || { xp: 0, games: 0, wins: 0, k: 0, d: 0, a: 0, best: 0 });

// ---------- 每日軍令：依日期決定，每天 3 道 ----------
const QUESTS = [
  { id: 'play2', text: '出戰 2 場', goal: 2, xp: 120, f: (s) => 1 },
  { id: 'win1', text: '取得 1 場勝利', goal: 1, xp: 200, f: (s) => s.win ? 1 : 0 },
  { id: 'kills8', text: '累計擊殺 8 名敵將', goal: 8, xp: 180, f: (s) => s.k },
  { id: 'assist12', text: '累計 12 次助攻', goal: 12, xp: 160, f: (s) => s.a },
  { id: 'tower3', text: '摧毀 3 座城寨', goal: 3, xp: 160, f: (s) => s.stat.towers },
  { id: 'cart1', text: '劫下 1 輛糧車', goal: 1, xp: 150, f: (s) => s.stat.carts },
  { id: 'chase10', text: '打出 10 次追擊', goal: 10, xp: 150, f: (s) => s.stat.chase },
  { id: 'dmg25k', text: '對敵將造成 25000 傷害', goal: 25000, xp: 180, f: (s) => Math.round(s.stat.dmgHero) },
  { id: 'quick1', text: '贏下 1 場速戰', goal: 1, xp: 180, f: (s) => s.win && s.mode === 'quick' ? 1 : 0 },
  { id: 'shu1', text: '用蜀將出戰 1 場', goal: 1, xp: 100, f: (s) => s.faction === 'shu' ? 1 : 0 },
  { id: 'wu1', text: '用吳將出戰 1 場', goal: 1, xp: 100, f: (s) => s.faction === 'wu' ? 1 : 0 },
  { id: 'wei1', text: '用魏將出戰 1 場', goal: 1, xp: 100, f: (s) => s.faction === 'wei' ? 1 : 0 },
  { id: 'gradeA', text: '拿到 A 以上的評價', goal: 1, xp: 220, f: (s) => 'SA'.includes(s.grade[0]) ? 1 : 0 },
];
// 小型可重現亂數：同一天每個人拿到同一組軍令（方便朋友間比較）
const hash = (str) => { let h = 2166136261; for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
const rng = (seed) => () => { seed = (seed + 0x6D2B79F5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
function daily() {
  const d = today();
  // 換日，或存檔裡有已經移除的軍令（例如抓摔）：重抽今天的三道
  if (!P.daily || P.daily.date !== d || P.daily.q.some((q) => !QUESTS.some((x) => x.id === q.id))) {
    const r = rng(hash('sankuo' + d)), pool = QUESTS.slice(), ids = [];
    while (ids.length < 3) ids.push(pool.splice((r() * pool.length) | 0, 1)[0].id);
    P.daily = { date: d, q: ids.map((id) => ({ id, n: 0, done: false })) };
    save();
  }
  return P.daily.q.map((q) => Object.assign({}, QUESTS.find((x) => x.id === q.id), q));
}
// 今日挑戰：每天一名指定武將，打贏得雙倍軍功
function dailyHero() { const r = rng(hash('hero' + today())); return SG.HEROES[(r() * SG.HEROES.length) | 0]; }

// 連續出征：每天第一場加成，斷一天就歸零
function touchLogin() {
  const d = today(), y = today(new Date(Date.now() - 864e5));
  if (P.login.last === d) return { days: P.login.days, first: false };
  P.login.days = P.login.last === y ? P.login.days + 1 : 1;
  P.login.last = d;
  return { days: P.login.days, first: true };
}

// ---------- 戰功（一次性成就） ----------
const ACH = [
  { id: 'first', name: '初陣', desc: '完成第一場戰鬥', f: (s) => true },
  { id: 'win', name: '首勝', desc: '取得第一場勝利', f: (s) => s.win },
  { id: 'fb', name: '先登', desc: '拿下第一滴血', f: (s) => s.stat.fb },
  { id: 'triple', name: '三英', desc: '一次三殺', f: (s) => s.stat.maxMulti >= 3 },
  { id: 'penta', name: '五虎', desc: '一次五殺', f: (s) => s.stat.maxMulti >= 5 },
  { id: 'streak7', name: '萬夫莫敵', desc: '連殺 7 人不死', f: (s) => s.stat.maxStreak >= 7 },
  { id: 'k15', name: '一騎當千', desc: '單場擊殺 15 名敵將', f: (s) => s.k >= 15 },
  { id: 'nodeath', name: '金剛不壞', desc: '零陣亡取勝', f: (s) => s.win && s.d === 0 && s.k + s.a >= 5 },
  { id: 'a20', name: '運籌帷幄', desc: '單場 20 次助攻', f: (s) => s.a >= 20 },
  { id: 'tower4', name: '攻城拔寨', desc: '單場摧毀 4 座城寨', f: (s) => s.stat.towers >= 4 },
  { id: 'cart2', name: '截糧斷道', desc: '單場劫下 2 輛糧車', f: (s) => s.stat.carts >= 2 },
  { id: 'seal', name: '受命於天', desc: '奪得傳國玉璽', f: (s) => s.stat.seal > 0 },
  { id: 'lubu', name: '轅門斬呂', desc: '親手擊敗呂布', f: (s) => s.stat.boss > 0 },
  { id: 'gradeS', name: '國士無雙', desc: '拿到 S 評價', f: (s) => s.grade === 'S' },
  { id: 'fast', name: '兵貴神速', desc: '9 分鐘內贏下速戰', f: (s) => s.win && s.mode === 'quick' && s.t < 540 },
  { id: 'ws3', name: '三連捷', desc: '連勝 3 場', f: (s) => P.winStreak >= 3 },
  { id: 'ws5', name: '勢如破竹', desc: '連勝 5 場', f: (s) => P.winStreak >= 5 },
  { id: 'tri', name: '三分歸一', desc: '蜀、吳、魏武將各贏一場', f: (s) => P.factionsWon.shu && P.factionsWon.wu && P.factionsWon.wei },
  { id: 'h10', name: '廣納賢才', desc: '用 10 名不同武將出戰', f: (s) => Object.values(P.heroes).filter((h) => h.games > 0).length >= 10 },
  { id: 'g50', name: '百戰老兵', desc: '出戰 50 場', f: (s) => P.games >= 50 },
  { id: 'm6', name: '名震天下', desc: '任一武將熟練度到頂', f: (s) => Object.values(P.heroes).some((h) => masteryOf(h.xp).lv >= 6) },
];

// ---------- 單場評價與稱號 ----------
function scoreOf(h, w) {
  const s = h.stat, mins = Math.max(4, w.t / 60);
  const raw = h.kills * 260 + h.assists * 130 - h.deaths * 140 + s.dmgHero / 18 + s.dmgBld / 14 + s.towers * 180 + s.carts * 160 + s.boss * 260 + s.seal * 120 + (h.lastHits || 0) * 6;
  return Math.max(0, Math.round(raw / mins * 10));
}
const gradeOf = (pm, win) => { const v = pm * (win ? 1.15 : 1); return v >= 2800 ? 'S' : v >= 1600 ? 'A' : v >= 800 ? 'B' : v >= 350 ? 'C' : 'D'; };
function titleOf(h, w) {
  const s = h.stat, team = w.heroes(h.team), top = (f) => team.every((o) => f(o) <= f(h));
  if (s.maxMulti >= 5) return ['五虎上將', '一口氣斬下五名敵將'];
  if (h.kills >= 12 && h.deaths <= 3) return ['一騎當千', '殺得敵軍聞風喪膽'];
  if (s.maxStreak >= 7) return ['萬夫莫敵', '連殺七人無人能擋'];
  if (w.over === h.team && h.deaths === 0 && h.kills + h.assists >= 5) return ['金剛不壞', '全場未嘗一敗'];
  if (s.towers >= 3 || (top((o) => o.stat.dmgBld) && s.dmgBld > 4000)) return ['攻城拔寨', '城寨在你面前一座座倒下'];
  if (h.assists >= 15 || (top((o) => o.assists) && h.assists >= 8)) return ['運籌帷幄', '每場勝仗背後都有你'];
  if (top((o) => o.stat.taken) && h.stat.taken > 15000) return ['銅牆鐵壁', '替全軍扛下最多傷害'];
  if (s.carts >= 2) return ['截糧斷道', '敵軍的糧草都進了你的營'];
  if (s.boss) return ['轅門斬呂', '連呂布都不是你的對手'];
  if (top((o) => o.stat.dmgHero)) return ['萬軍之勇', '全隊對將傷害第一'];
  if (w.over === h.team) return ['凱旋而歸', '與將士們共享勝利'];
  return ['雖敗猶榮', '留得青山在，不怕沒柴燒'];
}

// ---------- 結算：一場打完呼叫一次，回傳要給玩家看的所有東西 ----------
function record(w, opts) {
  opts = opts || {};
  const h = w.player, win = w.over === h.team, spec = h.spec;
  const pm = scoreOf(h, w), grade = gradeOf(pm, win), title = titleOf(h, w);
  const s = { win, mode: w.mode, t: w.t, k: h.kills, d: h.deaths, a: h.assists, lv: h.lv, cs: h.lastHits || 0, stat: Object.assign({}, h.stat), score: pm, grade, title, hero: spec.id, faction: spec.faction, skin: spec.skinId || 'base', battle: opts.battle || 'chibi' };
  const rank0 = rankOf(P.xp), hr = heroRec(spec.id), m0 = masteryOf(hr.xp);
  const login = touchLogin();
  // 軍功：基本＋勝利＋評價＋表現；每日第一場與今日武將另有加成
  const parts = [['出戰', 60], [win ? '勝利' : '參戰', win ? 120 : 30], ['評價 ' + grade, { S: 140, A: 100, B: 60, C: 30, D: 10 }[grade]], ['擊殺與助攻', Math.min(150, h.kills * 8 + h.assists * 4)]];
  if (w.mode === 'quick') parts[0][1] = 45;
  if (login.first) parts.push([`連續出征 ${login.days} 天`, Math.min(200, 60 + (login.days - 1) * 20)]);
  if (opts.dailyHero && win) parts.push(['今日武將', 150]);
  if (opts.challenge && opts.challenge.score && pm > opts.challenge.score) parts.push(['戰勝挑戰', 120]);
  // 每日軍令
  const qs = daily(), qDone = [];
  P.daily.q.forEach((q) => {
    if (q.done) return;
    const def = QUESTS.find((x) => x.id === q.id);
    q.n = Math.min(def.goal, q.n + def.f(s));
    if (q.n >= def.goal) { q.done = true; qDone.push(def); parts.push(['軍令：' + def.text, def.xp]); }
  });
  const xp2 = P.boost.xp2 > 0, m2 = P.boost.m2 > 0;
  if (xp2) { P.boost.xp2--; parts.push(['軍功雙倍卡', parts.reduce((a, p) => a + p[1], 0)]); }
  const gain = parts.reduce((a, p) => a + p[1], 0);
  P.xp += gain; P.games++;
  if (win) { P.wins++; P.winStreak++; P.bestStreak = Math.max(P.bestStreak, P.winStreak); P.factionsWon[spec.faction] = 1; } else P.winStreak = 0;
  if (m2) P.boost.m2--;
  const mGain = Math.round((gain * 0.8 + (win ? 60 : 0)) * (m2 ? 2 : 1));
  // 銅錢：出戰、勝負、評價、完成軍令；晉升軍階另有賞賜
  const coins = [['出戰', w.mode === 'quick' ? 30 : 40], [win ? '勝利' : '參戰', win ? 60 : 20], ['評價 ' + grade, COIN_GRADE[grade]]];
  if (qDone.length) coins.push([`完成軍令 ×${qDone.length}`, qDone.length * 50]);
  const rankUpTo = rankOf(P.xp);
  if (rankUpTo.i > rank0.i) coins.push([`晉升${rankUpTo.name}`, 200 * rankUpTo.i]);
  const copper = coins.reduce((a, p) => a + p[1], 0);
  // 會員：銅錢由伺服器發（瀏覽器只回報這場的結果，見 cloud.ts 的 econ/practice）；訪客照舊記在這台裝置
  const cloudWallet = !!(SG.Cloud && SG.Cloud.pid);
  if (!cloudWallet) P.copper += copper;
  const claim = { mode: w.mode, dur: Math.round(w.t), win, grade, quests: qDone.length, rank: rankOf(P.xp).i > rank0.i ? rankOf(P.xp).i : -1, xp2, m2 };
  hr.xp += mGain; hr.games++; if (win) hr.wins++; hr.k += h.kills; hr.d += h.deaths; hr.a += h.assists;
  const newBest = pm > hr.best; hr.best = Math.max(hr.best, pm);
  const m1 = masteryOf(hr.xp);
  const unlocks = SKINS.filter((k) => k.lv > m0.lv && k.lv <= m1.lv);
  const newAch = ACH.filter((a) => !P.ach[a.id] && a.f(s));
  newAch.forEach((a) => { P.ach[a.id] = today(); });
  P.history.unshift({ d: today(), at: Date.now(), hero: spec.id, win, k: h.kills, dd: h.deaths, a: h.assists, g: grade, sc: pm, m: w.mode, b: opts.battle || 'chibi', t: Math.round(w.t) }); // at：結束時間（雲端存檔合併排序用）
  P.history.length = Math.min(P.history.length, 30);
  save();
  const rank1 = rankOf(P.xp);
  return { s, parts, gain, rank0, rank1, rankUp: rank1.i > rank0.i, m0, m1, mGain, masteryUp: m1.lv > m0.lv, unlocks, newAch, qs: daily(), qDone, login, newBest, streak: P.winStreak, coins, copper, m2, claim, cloudWallet };
}

// ---------- 商域：銅錢（戰役取得）與黃金（儲值取得） ----------
const COIN_GRADE = { S: 80, A: 60, B: 40, C: 20, D: 10 };
const BOOSTS = [
  { id: 'xp2', name: '軍功雙倍卡', desc: '接下來 3 場的軍功加倍', n: 3, price: { copper: 600 } },
  { id: 'm2', name: '熟練雙倍卡', desc: '接下來 3 場的武將熟練度加倍', n: 3, price: { copper: 600 } },
];
const EXCHANGE = { gold: 10, copper: 800 }; // 黃金換銅錢
// 儲值方案（原型：沒有接金流，按下就直接入帳）；每個方案首次儲值贈送加倍
const TOPUP = [
  { id: 'g60', gold: 60, bonus: 0, price: 'NT$30' },
  { id: 'g300', gold: 300, bonus: 30, price: 'NT$150' },
  { id: 'g680', gold: 680, bonus: 80, price: 'NT$330' },
  { id: 'g1280', gold: 1280, bonus: 200, price: 'NT$590' },
];
const ownKey = (heroId, skinId) => heroId + ':' + skinId;
const shopSkins = () => SKINS.filter((k) => k.price && !k.event); // 限定造型不進每日特惠
// 每日特惠：依日期挑一名武將的一款商域造型打七折，大家同一天看到同一個
function deal() {
  const r = rng(hash('deal' + today())), hero = SG.HEROES[(r() * SG.HEROES.length) | 0], skin = shopSkins()[(r() * shopSkins().length) | 0];
  const cur = skin.price.copper ? 'copper' : 'gold';
  return { hero, skin, cur, full: skin.price[cur], price: Math.round(skin.price[cur] * 0.7) };
}
function priceOf(heroId, skin) {
  const d = deal(), cur = skin.price.copper ? 'copper' : 'gold';
  return { cur, amount: d.hero.id === heroId && d.skin.id === skin.id ? d.price : skin.price[cur] };
}
function pay(cur, amount) {
  if (!(amount > 0) || P[cur] < amount) return false;
  P[cur] -= amount; return true;
}
const CUR_NAME = { copper: '銅錢', gold: '黃金' };
function buySkin(heroId, skinId) {
  const skin = SKINS.find((k) => k.id === skinId && k.price);
  if (!skin || !SG.HEROES.some((h) => h.id === heroId)) return { ok: false, msg: '找不到這件商品' };
  if (P.owned[ownKey(heroId, skinId)]) return { ok: false, msg: '已經擁有' };
  if (skin.event && !eventOn(skin.event)) return { ok: false, msg: '不在活動期間，限定造型沒有上架' };
  if (skin.heroes && !skin.heroes.includes(heroId)) return { ok: false, msg: '這款造型只有指定武將能穿' };
  const p = priceOf(heroId, skin);
  if (!pay(p.cur, p.amount)) return { ok: false, msg: `${CUR_NAME[p.cur]}不足` };
  P.owned[ownKey(heroId, skinId)] = today(); save();
  return { ok: true, msg: `購得造型：${skin.name}` };
}
function buyBoost(id) {
  const b = BOOSTS.find((x) => x.id === id);
  if (!b) return { ok: false, msg: '找不到這件商品' };
  const cur = b.price.copper ? 'copper' : 'gold';
  if (!pay(cur, b.price[cur])) return { ok: false, msg: `${CUR_NAME[cur]}不足` };
  P.boost[id] += b.n; save();
  return { ok: true, msg: `購得${b.name}（剩 ${P.boost[id]} 場）` };
}
function exchange() {
  if (!pay('gold', EXCHANGE.gold)) return { ok: false, msg: '黃金不足' };
  P.copper += EXCHANGE.copper; save();
  return { ok: true, msg: `兌換 ${EXCHANGE.copper} 銅錢` };
}
// 儲值還沒串接金流：正式網站一律關閉（SG.TOPUP_OPEN 只給測試與本機示範用）
const topUpOpen = () => !!SG.TOPUP_OPEN;
function topUp(id) {
  if (!topUpOpen()) return { ok: false, msg: '儲值尚未開放' };
  const t = TOPUP.find((x) => x.id === id);
  if (!t) return { ok: false, msg: '找不到這個方案' };
  const first = !P.topups[id], got = t.gold + (first ? t.gold : t.bonus);
  P.gold += got; P.topups[id] = (P.topups[id] || 0) + 1; save();
  return { ok: true, msg: `入帳 ${got} 黃金${first ? '（首儲加倍）' : ''}`, got };
}

// ---------- 挑戰碼：把戰績壓進網址，朋友點開就看到「超越我」 ----------
const b64 = (str) => btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const unb64 = (str) => decodeURIComponent(escape(atob(str.replace(/-/g, '+').replace(/_/g, '/'))));
function encodeChallenge(r, name) {
  const s = r.s;
  return b64(JSON.stringify({ h: s.hero, m: s.mode, k: s.k, d: s.d, a: s.a, sc: s.score, g: s.grade, w: s.win ? 1 : 0, t: Math.round(s.t), ti: s.title[0], n: (name || '').slice(0, 12), sk: s.skin, r: r.rank1.name, day: today() }));
}
function decodeChallenge(code) {
  try {
    const o = JSON.parse(unb64(code));
    const hero = SG.HEROES.find((h) => h.id === o.h);
    if (!hero || typeof o.sc !== 'number') return null;
    return { hero, mode: o.m === 'quick' ? 'quick' : 'std', k: o.k | 0, d: o.d | 0, a: o.a | 0, score: o.sc | 0, grade: String(o.g || 'D').slice(0, 1), win: !!o.w, t: o.t | 0, title: String(o.ti || '').slice(0, 8), name: String(o.n || '').slice(0, 12), skin: String(o.sk || 'base'), rank: String(o.r || '').slice(0, 6), day: String(o.day || '') };
  } catch (e) { return null; }
}

// 黃金獎勵：每個戰功 10 黃金、列傳每顆星 5 黃金，各只領一次，玩家按「領取」才入帳
// 領過的記在 P.econ.ach / P.econ.star：會員的 econ 是伺服器那份（server/economy.ts 的 claim 發黃金），跟著存檔回來；
// 訪客的記在這台裝置（第一次上傳雲端時伺服器會清掉，連同訪客時期的黃金）
const GOLD_ACH = 10, GOLD_STAR = 5;
const claimedOf = () => Object.assign({ ach: {}, star: {} }, P.econ && { ach: P.econ.ach || {}, star: P.econ.star || {} });
// 還沒領的：拿到的戰功、星數（stars：{ 章節 id: 星數 }）扣掉領過的
function unclaimed(stars) {
  const c = claimedOf(), ach = ACH.filter((a) => P.ach[a.id] && !c.ach[a.id]).map((a) => a.id), st = {};
  let n = 0;
  for (const [id, k] of Object.entries(stars || {})) if (k > (c.star[id] || 0)) { st[id] = k; n += k - (c.star[id] || 0); }
  return { ach, stars: st, nStars: n, gold: ach.length * GOLD_ACH + n * GOLD_STAR };
}
// 訪客領取：ach、stars 同上。回傳這次新領到的 { gold, ach, stars }
function claimLocal(ach, stars) {
  P.econ = Object.assign({}, P.econ); const c = P.econ; c.ach = Object.assign({}, c.ach); c.star = Object.assign({}, c.star);
  const got = { gold: 0, ach: 0, stars: 0 };
  for (const id of ach) if (ACH.some((a) => a.id === id) && !c.ach[id]) { c.ach[id] = today(); got.ach++; }
  for (const [id, n] of Object.entries(stars)) { const k = Math.max(0, Math.min(4, Math.floor(Number(n) || 0))), was = c.star[id] || 0; if (k > was) { got.stars += k - was; c.star[id] = k; } }
  got.gold = got.ach * GOLD_ACH + got.stars * GOLD_STAR;
  if (got.gold) { P.gold += got.gold; save(); }
  return got;
}
// 新手提示：每個提示每個存檔只出現一次
function tip(id) { if (P.tips[id]) return false; P.tips[id] = 1; save(); return true; }

load();
SG.Meta = {
  RANKS, SKINS, EVENTS, activeEvents, eventsAround, ACH, QUESTS, MASTERY_NAME, GOLD_ACH, GOLD_STAR, claimLocal, unclaimed, claimedOf,
  get profile() { return P; }, load, save, reset() { P = fresh(); save(); },
  // 雲端存檔：整份換掉（不觸發上傳）、存檔後的通知
  replace(p) { P = Object.assign(fresh(), p); P.boost = Object.assign({ xp2: 0, m2: 0 }, P.boost); try { if (store) store.setItem(KEY, JSON.stringify(P)); } catch (e) { /* 忽略 */ } },
  onSave(f) { saveHooks.push(f); },
  // 謀略（v0.3.0）：只有會員有；療傷一律有，其餘看錢包 owned（伺服器保管）。帶哪一個記在 profile.ml
  mlOwned() { return SG.Cloud && SG.Cloud.pid && SG.mlOwned ? SG.mlOwned(P.owned) : []; },
  mlChosen() { const o = SG.Meta.mlOwned(); return o.includes(P.ml) ? P.ml : o[0] || null; },
  setMl(id) { P.ml = id; save(); },
  rankOf, masteryOf, heroRec, skinned, daily, dailyHero, record, scoreOf, gradeOf, titleOf, encodeChallenge, decodeChallenge, tip, today,
  skinFor(id) { return P.skin[id] || 'base'; },
  setSkin(id, sk) { P.skin[id] = sk; save(); },
  skinsChosen() { const o = {}; for (const [id, sk] of Object.entries(P.skin)) if (sk && sk !== 'base' && this.skinUnlocked(id, sk)) o[id] = sk; return o; }, // 連線對戰時送給伺服器
  skinUnlocked(id, sk) { const k = SKINS.find((s) => s.id === sk); return !!k && (k.price ? !!P.owned[ownKey(id, sk)] : masteryOf((P.heroes[id] || { xp: 0 }).xp).lv >= k.lv); },
  BOOSTS, TOPUP, EXCHANGE, CUR_NAME, deal, priceOf, buySkin, buyBoost, exchange, topUp, topUpOpen,
  // 暱稱：設定一次，連線對戰都用它（之後有會員就改用帳號名稱）
  setNick(n) { P.nick = String(n || '').replace(/[\u0000-\u001f]/g, '').trim().slice(0, 12); save(); return P.nick; },
};
